import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Tours from "./pages/Tours";
import TourDetail from "./pages/TourDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MyTrips from "./pages/MyTrips";
import Admin from "./pages/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }
  handleReset = () => {
    try { localStorage.clear(); } catch (e) {}
    window.location.href = "/";
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-slate-50 px-5 text-center">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Something went wrong</h1>
            <p className="mt-2 text-slate-500">Please reload the page. If this keeps happening, reset your session.</p>
            <button onClick={this.handleReset} className="mt-5 bg-coral-600 hover:bg-coral-700 text-white rounded-lg px-5 py-2.5 font-medium">
              Reset & reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function Chrome() {
  const { pathname } = useLocation();
  const hideNav = ["/login", "/register"].includes(pathname);
  return !hideNav ? <Navbar /> : null;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <ThemeProvider>
          <AuthProvider>
            <BrowserRouter>
              <ScrollTop />
              <Chrome />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tours" element={<Tours />} />
                <Route path="/tour/:slug" element={<TourDetail />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/my-trips" element={<MyTrips />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
              <Toaster />
            </BrowserRouter>
          </AuthProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
